const baseURL = '/files';

const deleteFile = (filePath) => {
    return axios.delete(`${baseURL}${filePath}`).then(R.prop('data'));
};

export default { deleteFile };
